// How many trials one Excel export takes (exportExcelReport.js), by the chosen layout.
import { parseLayoutFields } from '../../components/Reports/layouts';

export const MAX_EXPORT_TRIALS = 10000;
// A layout with task fields gives a row per task (often 15-20 a trial), all built in the browser
export const MAX_EXPORT_TRIALS_WITH_TASKS = 2000;

/** Whether a layout's fields include task (diary) fields, which give a row per task. */
export const hasTaskFields = (fields) => fields.some((key) => key.startsWith('diaries.'));

/** The most trials one export of this layout ({ definition }) takes. */
export const exportLimit = (layout) => (hasTaskFields(parseLayoutFields(layout)) ? MAX_EXPORT_TRIALS_WITH_TASKS : MAX_EXPORT_TRIALS);
